import { render } from "./TreeBoard.vue?vue&type=template&id=fe3eea22&scoped=true"
import script from "./TreeBoard.vue?vue&type=script&lang=js"
export * from "./TreeBoard.vue?vue&type=script&lang=js"

import "./TreeBoard.vue?vue&type=style&index=0&id=fe3eea22&lang=sass"
import "./TreeBoard.vue?vue&type=style&index=1&id=fe3eea22&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3eea22"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QTree});
